import React from "react";
import { WrapperItem, Product } from "./Style";
import CardLoading from "../Item";

const FilteredHomeItem = () => {
  return (
    <WrapperItem>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
      <Product>
        <CardLoading />
      </Product>
    </WrapperItem>
  );
};

export default FilteredHomeItem;
